import { required } from '../../../../utils/validators';

export const constraints = {
  username: [required()],
  password: [required()],
};

export interface FormData {
  username: string;
  password: string;
}
